import React from 'react';
import styled from 'styled-components';
import PermWrapper from '@/components/PermWrapper';
import ToRemote from './ToRemote';
import FromRemote from './FromRemote';
import PartitionLimiting from './PartitionLimiting';

export default function GeoPanel({ commonProps, closeDrawer }) {
  return (
    <>
      <GroupTitle>限流配置</GroupTitle>
      <PermWrapper resource='pulsar:topic:list:GEOPolice'>
        <PartitionLimiting commonProps={commonProps} />
      </PermWrapper>
      <ToRemote commonProps={commonProps} closeDrawer={closeDrawer} />
      <FromRemote commonProps={commonProps} closeDrawer={closeDrawer} />
    </>
  );
}

const GroupTitle = styled.div`
  color: rgb(13, 17, 26);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  padding: 20px 0 20px 3px;
`;
